import script from "./KatelynBirthdaySurprise.vue?vue&type=script&setup=true&lang=ts"
export * from "./KatelynBirthdaySurprise.vue?vue&type=script&setup=true&lang=ts"

import "./KatelynBirthdaySurprise.vue?vue&type=style&index=0&id=4a4e8cd4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a4e8cd4"]])

export default __exports__